import {
  formatDate,
  formatDateNice,
} from './format-date'

import { concat } from './concat'
import { formatUcfirst } from './format-ucfirst'
import { formatCustomerName } from './format-customer-name'
import { formatServicePrice } from './format-service-price'
import { formatCurrency } from './format-currency'
import { formatPrecision } from './format-precision'

import { formatSubscriptionCurrency } from './format-subscription-currency'

import { formatRelativeDelta } from './format-relative-delta'

type UseFiltersResult = {
  formatDate: typeof formatDate
  formatDateNice: typeof formatDateNice
  concat: typeof concat
  formatCustomerName: typeof formatCustomerName
  formatServicePrice: typeof formatServicePrice
  formatCurrency: typeof formatCurrency
  formatUcfirst: typeof formatUcfirst
  formatRelativeDelta: typeof formatRelativeDelta
  formatSubscriptionCurrency: typeof formatSubscriptionCurrency
  formatPrecision: typeof formatPrecision
}

export function useFilters (): UseFiltersResult {
  return {
    formatDate,
    formatDateNice,
    concat,
    formatCustomerName,
    formatServicePrice,
    formatCurrency,
    formatUcfirst,
    formatRelativeDelta,
    formatSubscriptionCurrency,
    formatPrecision,
  }
}
